import { Profile2User, Setting2 } from 'iconsax-reactjs';

import { NavItemType } from 'types/menu';

const icons = {
  usuarios: Profile2User,
  settings: Setting2
};

const administracion: NavItemType = {
  id: 'group-administracion',
  title: 'menu.group.administracion',
  type: 'group',
  children: [
    {
      id: 'usuarios',
      title: 'menu.item.usuarios',
      type: 'item',
      url: '/admin/usuarios/grupos',
      icon: icons.usuarios,
      breadcrumbs: false,
      permissions: ['usuarios.ver', 'usuarios.gestionar_grupos']
    },
    {
      id: 'settings',
      title: 'menu.item.settings',
      type: 'item',
      url: '/admin/settings',
      icon: icons.settings,
      breadcrumbs: false,
      permissions: ['usuarios.gestionar_grupos']
    }
  ]
};

export default administracion;
